var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-group-item p-0"},[_c('div',{staticClass:"row pr-3 pl-3 mb-1 align-items-center"},[_c('div',{staticClass:"col-12 text-center",staticStyle:{"height":"80px","background-color":"#ffffff"}},[(_vm.item)?_c('img',{staticClass:"logo",attrs:{"src":_vm.getLogoCooperativa,"alt":_vm.item.nombre}}):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }